import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { AuthService } from "src/app/providers/auth.service";
import { DialogService } from "src/app/providers/dialog.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AssignJobComponent } from "src/app/shared/components/assign-job/assign-job.component";
import { ManageBookingComponent } from "src/app/shared/components/manage-booking/manage-booking.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { MeetingDataForAppointmentComponent } from "../new-v2-component/meeting-data-for-appointment/meeting-data-for-appointment.component";
import { CancelBookingNotesModalComponent } from "src/app/shared/components/cancel-booking-notes-modal/cancel-booking-notes-modal.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { CustomiseBookingComponent } from "src/app/shared/components/customise-booking/customise-booking.component";
import { InvoiceComponent } from "src/app/shared/components/invoice/invoice.component";
import { environment } from "src/environments/environment";
import { CopyLinkCompComponent } from "../new-v2-component/copy-link-comp/copy-link-comp.component";
import { Share } from "@capacitor/share";
import { CancelDeleteActivityForBookingAndInvoiceComponent } from "src/app/shared/components/cancel-delete-activity-for-booking-and-invoice/cancel-delete-activity-for-booking-and-invoice.component";
import { AskBusinessRatingComponent } from "src/app/shared/components/ask-business-rating/ask-business-rating.component";

@Component({
  selector: "sm-booking-details-page",
  templateUrl: "./booking-details-page.component.html",
  styleUrls: ["./booking-details-page.component.scss"],
})
export class BookingDetailsPageComponent implements OnInit, OnDestroy {
  loader: boolean = false;
  apisub: Subscription;
  discountInfo: any;
  bookingsData: any = [];
  isfuture: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private navservice: NavigationService,
    private apiservice: ApiService,
    private ls: LoaderServiceService,
    private authService: AuthService,
    private _modelRef: MatDialog,
    private dialogService: DialogService,
    private router: Router
  ) {
    this.navservice.hideSidebarAndNav = false;

    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_BOOKING_DETAIL_BY_ID
      ) {
        if (resdata.result) {
          console.log(resdata);
          this.bookingsData = resdata.result ? resdata.result : [];
          this.bookingsData = this.sortObjectsDescendingByBookingNumber(
            this.bookingsData
          );

          this.bookingsData.forEach((element: any) => {
            if (element.customerInfo) {
              element.customerInfo = JSON.parse(element.customerInfo);
              element.customerName = element.customerInfo.name;
              element.customerPhone = element.customerInfo.phone;
            }

            if (element.serviceInfo) {
              if (element.serviceInfo != null) {
                element.serviceInfo =
                  typeof element.serviceInfo == "string"
                    ? JSON.parse(element.serviceInfo)
                    : element.serviceInfo;
                element.servicesArray = [];
                element.serviceInfo.forEach((item: any) => {
                  element.servicesArray.push(" " + item.serviceName);
                });
              }
            }
            if (element.custom_items) {
              if (element.custom_items != null) {
                element.custom_items =
                  typeof element.custom_items == "string"
                    ? JSON.parse(element.custom_items)
                    : element.custom_items;
                element.customItemsArray = [];
                element.serviceInfo.forEach((item: any) => {
                  element.customItemsArray.push(" " + item.item_name);
                });
              }
            }
            if (element.appointment_products) {
              if (element.appointment_products != null) {
                element.appointment_products =
                  typeof element.appointment_products == "string"
                    ? JSON.parse(element.appointment_products)
                    : element.appointment_products;
                // element.customItemsArray = []
                // element.serviceInfo.forEach((item:any) => {
                //   element.customItemsArray.push(' ' + item.item_name)
                // });
              }
            }

               if (element.booking_address) {
              if (element.booking_address != null) {
                element.booking_address =
                  typeof element.booking_address == "string"
                    ? JSON.parse(element.booking_address)
                    : element.booking_address;
              }
            }

            if (element.entityInfo) {
              if (element.entityInfo != null) {
                element.entityInfo =
                  typeof element.entityInfo == "string"
                    ? JSON.parse(element.entityInfo)
                    : element.entityInfo;
              }
            }

            if (element.payments) {
              if (element.payments != null) {
                element.payments =
                  typeof element.payments == "string"
                    ? JSON.parse(element.payments)
                    : element.payments;
              }
            }

            element.costing = element.currency_symbol
              ? element.currency_symbol + element.price
              : "₹" + element.price;

            if (element.customer_name == "null" || !element.customer_name) {
              element.cust_name = "New Customer";
            } else if (
              element.customer_name != "null" ||
              element.customer_name
            ) {
              element.cust_name = element.customer_name;
            }

            if (element.customer_phone == "null" || !element.customer_phone) {
              element.cust_phn = "---";
            } else if (
              element.customer_phone != "null" ||
              element.customer_phone
            ) {
              element.cust_phn =
                element.country_code + " " + element.customer_phone;
            }

            if (element.paymentStatus === 0 || !element.paymentStatus) {
              element.paymentStat = "Due";
            } else if (element.paymentStatus == 1) {
              element.paymentStat = "Done";
            } else if (element.paymentStatus == 2) {
              element.paymentStat = "Payment in progress";
            } else if (element.paymentStatus == 3) {
              element.paymentStat = "Error in payment";
            } else {
              element.paymentStat = "---";
            }

            // }

            if (element.bookingStartTime && element.bookingStartTime != null) {
              element.bookingStartTime = element.bookingStartTime.slice(0, 5);
            }
            if (element.bookingEndTime && element.bookingEndTime != null) {
              element.bookingEndTime = element.bookingEndTime.slice(0, 5);
            }

            if (
              element.bookingStatus == 0 ||
              element.bookingStatus == 1 ||
              element.bookingStatus == 2
            ) {
              element.bookingStat = "New booking";
            } else if (element.bookingStatus == 3) {
              element.bookingStat = "Under process";
            } else if (element.bookingStatus == 4) {
              element.bookingStat = "Completed";
            } else if (element.bookingStatus == 5) {
              element.bookingStat = "Booking confirmed";
            } else if (element.bookingStatus == 6) {
              element.bookingStat = "Cancelled by User";
            } else if (element.bookingStatus == 7) {
              element.bookingStat = "Assigned";
            } else if (element.bookingStatus == 8) {
              element.bookingStat = "Cancelled";
            } else if (element.bookingStatus == 9) {
              element.bookingStat = "Partially Complete";
            }

            if (!element.employeeName) {
              element.employeeName = "---";
            }

            if (element.bookingType == "1") {
              element.bType = "Shop";
            }
            if (element.bookingType == "0") {
              element.bType = "Home";
            }
            if (element.bookingType == "2") {
              element.bType = "Virtual";
            }

            let isEntityForeign = element.currency == "INR" ? "0" : "1";

            localStorage.setItem(
              SM_CONSTANTS.IS_ENTITY_FOREIGN,
              isEntityForeign
            );

            const todayStr = this.formatDate1(new Date());
            const bookingStr = this.formatDate1(element.bookingDate);

            // isFuture will be true if booking date is after today
            this.isfuture = bookingStr > todayStr;
          });

          this.ls.showLoader = false;
          this.loader = false;

          console.log(this.bookingsData);
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resdata.result) {
          this.discountInfo = resdata.result;
        }
        this.apiservice.getBookingDetailById(this.bookingHash);
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS
      ) {
        this.apiservice.getBookingDetailById(this.bookingHash);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE
      ) {
        this.apiservice.getBookingDetailById(this.bookingHash);
        // alert("Invoice generated")
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_RESET_BOOKING_DETAILS
      ) {
        this.apiservice.getBookingDetailById(this.bookingHash);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_CUSTOMISE_BOOKING_DETAILS
      ) {
        this.apiservice.getBookingDetailById(this.bookingHash);
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
        this.apiservice.getBookingDetailById(this.bookingHash);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        this.apiservice.getBookingDetailById(this.bookingHash);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_APPOINTMENT_DATA
      ) {
        this.router.navigate(["../"], {
          relativeTo: this.route,
          queryParamsHandling: "preserve",
        });
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        this.apiservice.getBookingDetailById(this.bookingHash);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (resdata.result) {
          this.apiservice.getBookingDetailById(this.bookingHash);
        }
      }
        if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_CANCEL_ENTITY_APPOINTMENT_DATA
      ) {
        if (resdata.result) {
          this.apiservice.getBookingDetailById(this.bookingHash);
        }
      }
    });
  }
  bookingHash: any;
  entityHashId: any;
    eph: any;
  isOwner: boolean = false;
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
       if (sessionStorage.getItem(SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS)) {
      this.advancePaymentSettings =
        typeof sessionStorage.getItem(
          SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS
        ) == "string"
          ? JSON.parse(
              sessionStorage.getItem(
                SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS
              )!
            )
          : sessionStorage.getItem(
              SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS
            );
    }
    this.route.queryParams.subscribe((data) => {
      if (data.bookingHash) {
        this.bookingHash = data.bookingHash;
        this.entityHashId = data.entityHash;
        this.eph = data.eph;
        this.loader = true;
        this.ls.showLoader = true;

        this.apiservice.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );
      }
    });
  }

  sortObjectsDescendingByBookingNumber(array: any) {
    return array
      .slice()
      .sort(
        (a: any, b: any) =>
          parseInt(b.appointment_no) - parseInt(a.appointment_no)
      );
  }
  selectedValue: any = "0";

  confirmBooking(item: any) {
    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        appointmentHash: item.hash_id,
        bookingStatus: 5,
        startTime: item.bookingStartTime.slice(0, 5),
        endTime: item.bookingEndTime.slice(0, 5),
        entityHash: item.entityHash,
        countryCode: item.country_code,
        customerPh: item.customer_phone,
        customerName: item.customer_name,
        price: item.price,
        bookingDate: this.formatDateString(new Date(item.bookingDate)),
        note: item.note,
        bookingType: item.bookingType,
        customerHash: item.customerInfo.hash_id,
      },
    };

    console.log(data);
    this.ls.showLoader = true;
    this.apiservice.updateBookingStatus(data);
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  startProcess(item: any) {
    if (this.getAccessStatus()) {
      let data = {
        bookingStatusInfo: {
          assignedToHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          assignedByHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          appointmentHash: item.hash_id,
          bookingStatus: 3,
          startTime: this.formatTime(new Date()),
          endTime: this.addOneHour(this.formatTime(new Date())),
          entityHash: item.entityHash,
          countryCode: item.country_code,
          customerPh: item.customer_phone,
          customerName: item.customer_name,
          price: item.price,
          bookingDate: item.bookingDate,
          note: item.note,
          bookingType: item.bookingType,
          customerHash: item.customerInfo.hash_id,
        },
      };

      console.log(data);
      this.ls.showLoader = true;
      this.apiservice.updateBookingStatus(data);
    } else {
      const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
                width: "400px",
        data: {
          title: "Access denied",
          message:
            "You do not have access to this job. It's not assigned to you. Ask the corresponding person to assign the job to you.",
          okbtn: "Ok",
          cancelbtn: "Ok",
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
    }
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  addOneHour(timeStr: any) {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);

    // Add one hour
    date.setHours(date.getHours() + 1);

    // Format back to HH:mm
    const newHours = String(date.getHours()).padStart(2, "0");
    const newMinutes = String(date.getMinutes()).padStart(2, "0");

    return `${newHours}:${newMinutes}`;
  }

  assignJob(item: any) {
    let data = {
      title: "Assign job",
      ref: this._modelRef,
      data: item,
    };
    this.dialogService.openFullScreenDialog(AssignJobComponent, data);
  }

  done(item: any) {
    if (this.getAccessStatus()) {
      let data = {
        title: "Manage Booking",
        ref: this._modelRef,
        data: {
          entityHash: this.entityHashId,
          serviceType: item.bookingType,
          bookingData: item,
          discountInfo: this.discountInfo,
        },
      };
      this.dialogService.openFullScreenDialog(ManageBookingComponent, data);
    } else {
      const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
                width: "400px",
        data: {
          title: "Access denied",
          message:
            "You do not have access to this job. It's not assigned to you. Ask the corresponding person to assign the job to you.",
          okbtn: "Ok",
          cancelbtn: "Ok",
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
    }
  }

  customiseBooking(item: any) {
    this.ls.showLoader = true;
    let data = {
      title: "Edit Booking Operation",
      ref: this._modelRef,
      data: {
        entityHash: this.entityHashId,
        serviceType: item.bookingType,
        bookingData: item,
        discountInfo: this.discountInfo,
      },
    };
    this.dialogService.openFullScreenDialog(CustomiseBookingComponent, data);
  }

  addEditMeetingData(item: any) {
    let dialogref = this._modelRef.open(MeetingDataForAppointmentComponent, {
      width: "500px",
      data: {
        data: item,
        isOwner: this.isOwner,
      },
    });
    dialogref.afterClosed().subscribe((data) => {
      if (data) {
        this.apiservice.getBookingDetailById(this.bookingHash);
      }
    });
    // if (this.getAccessStatus()) {
    // } else {
    //   const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
    //             width: "400px",
    //     data: {
    //       title: "Access denied",
    //       message:
    //         "You do not have access to this job. It's not assigned to you. Ask the corresponding person to assign the job to you.",
    //       okbtn: "Ok",
    //       cancelbtn: "Ok",
    //       type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
    //     },
    //     disableClose: true,
    //   });
    // }
  }

  reset(item: any) {
    // if(confirm("This will remove all the operation data like booked services, completed services status, employee engagement, etc. The appointment status will become NEW once again. Are you sure you want to continue?")){
    //   let data =  {
    //     appointmentHashId: item.hash_id
    //   }
    //   this.ls.showLoader = true
    //   this.apiservice.resetBookingDetails(data)
    // }

    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      maxWidth: "700px",
      data: {
        title: "Alert",
        message:
          "This will remove all the operation data like booked services, completed services status, employee engagement, etc. The appointment status will become NEW once again. Are you sure you want to continue?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          appointmentHashId: item.hash_id,
        };
        this.ls.showLoader = true;
        this.apiservice.resetBookingDetails(data);
      }
    });
  }

  openInvoice(item: any) {
    if(this.getAccessStatus()){
      let data = {
        title: "Invoice",
        ref: this._modelRef,
        showmerge: 1,
        data: item.hash_id,
      };
      this.dialogService.openFullScreenDialog(InvoiceComponent, data);
      
    }
    else{
      const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
                width: "400px",
        data: {
          title: "Access denied",
          message:
            "You do not have access to this job. It's not assigned to you. Ask the corresponding person to assign the job to you.",
          okbtn: "Ok",
          cancelbtn: "Ok",
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
    }
  }

  cancelBooking(item: any) {
    // PAYMENT NOT DONE
    // SHOW GENERIC ALERT AND INTERNALLY 'DO NOT' SEND REFUND STATUS
    if (
      this.bookingsData[0].payments &&
      this.bookingsData[0].payments.length == 0
    ) {
      console.log("1st case");

      const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
        width: "500px",
        data: {
          title: "Alert",
          message: "Are you sure you want to cancel this booking?",
          okbtn: "Yes, cancel",
          cancelbtn: "No",
          type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);
        if (result) {
          let notedialogref = this._modelRef.open(
            CancelBookingNotesModalComponent,
            {
              width: "600px",
              data: {
                title: "Cancel Booking",
              },
            }
          );
          notedialogref.afterClosed().subscribe((res) => {
            if (res) {
              let data = {
                appointment_hash: item.hash_id,
                // wallter_refund_status: 0,
                cancellation_notes: res.notes,
                creation_date: this.formatDateStringforcancel(new Date()),
                created_by: localStorage.getItem(
                  SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
                ),
                // refund_type: 2,
                is_foreign: this.bookingsData[0].currency === "INR" ? 0 : 1,
                entity_public_hash: this.eph,
                entity_hash: this.entityHashId,
                account_hash: localStorage.getItem(
                  SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
                ),
              };
              console.log(data);
              this.ls.showLoader = true;
              this.apiservice.cancelEntityAppointmentData(data);
            }
          });
        }
      });
    }
    // PAYMENT DONE (ADVANCE/FULL)
    else {
      // CHECK IF PAYMENTS CONSISTS OF ONLINE (RAZORPAY || PAYPAL)
      // IF EXISTS THEN SHOW CUSTOM ALERT AND INITIATE REFUND OR NOT
      const totalOnline = this.calculateOnlineTotal(
        this.bookingsData[0].payments
      );

      if (totalOnline > 0) {
        const dialogRef = this._modelRef.open(
          CancelDeleteActivityForBookingAndInvoiceComponent,
          {
            width: "750px",
            data: {
              title: "Alert",
              message:
                "Are you sure you want to cancel this appointment? There's a " +
                this.bookingsData[0].currency_symbol +
                totalOnline.toFixed(2) +
                " online payment associated with it.",
              okbtn: "Cancel and refund online",
              okbtn2: "Cancel and transfer to wallet",
              cancelbtn: "Do not cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
            },
            disableClose: true,
          }
        );
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            let notedialogref = this._modelRef.open(
              CancelBookingNotesModalComponent,
              {
                width: "600px",
                data: {
                  title: "Cancel Booking",
                },
              }
            );
            notedialogref.afterClosed().subscribe((res) => {
              if (res) {
                let data = {
                  appointment_hash: item.hash_id,
                  // wallter_refund_status: result.refund,
                  cancellation_notes: res.notes,
                  creation_date: this.formatDateStringforcancel(new Date()),
                  created_by: localStorage.getItem(
                    SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
                  ),
                  refund_type: result.refund_status,
                  is_foreign: this.bookingsData[0].currency === "INR" ? 0 : 1,
                  entity_public_hash: this.eph,
                  entity_hash: this.entityHashId,
                  account_hash: localStorage.getItem(
                    SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
                  ),
                };
                console.log(data);
                this.ls.showLoader = true;
                this.apiservice.cancelEntityAppointmentData(data);
              }
            });
          }
        });
      }
      // ELSE SHOW GENERIC ALERT AND INTERNALLY SEND REFUND STATUS AS 2
      else {
        console.log("3rd case");

        const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
          width: "500px",
          data: {
            title: "Alert",
            message: "Are you sure you want to cancel this booking?",
            okbtn: "Yes, cancel",
            cancelbtn: "No",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            let notedialogref = this._modelRef.open(
              CancelBookingNotesModalComponent,
              {
                width: "600px",
                data: {
                  title: "Cancel Booking",
                },
              }
            );
            notedialogref.afterClosed().subscribe((res) => {
              if (res) {
                let data = {
                  appointment_hash: item.hash_id,
                  // wallter_refund_status: 0,
                  cancellation_notes: res.notes,
                  creation_date: this.formatDateStringforcancel(new Date()),
                  created_by: localStorage.getItem(
                    SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
                  ),
                  refund_type: 2,
                  is_foreign: this.bookingsData[0].currency === "INR" ? 0 : 1,
                  entity_public_hash: this.eph,
                  entity_hash: this.entityHashId,
                  account_hash: localStorage.getItem(
                    SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
                  ),
                };
                console.log(data);
                this.ls.showLoader = true;
                this.apiservice.cancelEntityAppointmentData(data);
              }
            });
          }
        });
      }
    }
  }


  deleteBooking(item: any) {
    // PAYMENT NOT DONE
    // SHOW GENERIC ALERT AND INTERNALLY 'DO NOT' SEND REFUND STATUS
    if (
      this.bookingsData[0].payments &&
      this.bookingsData[0].payments.length == 0
    ) {
      const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
        width: "500px",
        data: {
          title: "Alert",
          message: "Are you sure you want to delete this booking?",
          okbtn: "Yes",
          cancelbtn: "No",
          type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);
        if (result) {
          let obj = {
            appointmentHash: item.hash_id,
            creation_time: this.formatDateStringforcancel(new Date()),
            created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
            is_foreign: this.bookingsData[0].currency === "INR" ? 0 : 1,
            entity_public_hash: this.eph,
            entity_hash: this.entityHashId,
            // walletRefundStatus: 0,
            // refund_type: 2,
            account_hash: localStorage.getItem(
              SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
            ),
          };

          this.ls.showLoader = true;
          this.apiservice.deleteEntityAppointmentData(obj);
        }
      });
    }
    // PAYMENT DONE (ADVANCE/FULL)
    else {
      // CHECK IF PAYMENTS CONSISTS OF ONLINE (RAZORPAY || PAYPAL)
      // IF EXISTS THEN SHOW CUSTOM ALERT AND INITIATE REFUND OR NOT
      // TECHNICALLY SHOULD NOT COME HERE
      const totalOnline = this.calculateOnlineTotal(
        this.bookingsData[0].payments
      );

      if (totalOnline > 0) {
        const dialogRef = this._modelRef.open(
          CancelDeleteActivityForBookingAndInvoiceComponent,
          {
            width: "600px",
            data: {
              title: "Alert",
              message:
                "Are you sure you want to delete this appointment? There's a " +
                this.bookingsData[0].currency_symbol +
                totalOnline.toFixed(2) +
                " online payment associated with it.",
              okbtn: "Delete and refund online",
              okbtn2: "Delete and transfer to wallet",
              cancelbtn: "No",
              type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
            },
            disableClose: true,
          }
        );
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            let data = {
                  appointmentHash: item.hash_id,
                  walletRefundStatus: 0,
                  creation_time: this.formatDateStringforcancel(new Date()),
                  created_by: localStorage.getItem(
                    SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
                  ),
                  refund_type: result.refund_status,
                  is_foreign: this.bookingsData[0].currency === "INR" ? 0 : 1,
                  entity_public_hash: this.eph,
                  entity_hash: this.entityHashId,
                  account_hash: localStorage.getItem(
                    SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
                  ),
                };
                console.log(data);
                this.ls.showLoader = true;
                this.apiservice.deleteEntityAppointmentData(data);
          }
        });
      }
      // ELSE SHOW GENERIC ALERT AND INTERNALLY SEND REFUND STATUS AS 2
      else {
        console.log("3rd case");

        const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
          width: "500px",
          data: {
            title: "Alert",
            message: "Are you sure you want to delete this booking?",
            okbtn: "Yes",
            cancelbtn: "No",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            let obj = {
              appointmentHash: item.hash_id,
              walletRefundStatus: 0,
              creation_time: this.formatDateStringforcancel(new Date()),
              created_by: localStorage.getItem(
                SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
              ),
              refund_type: 2,
              is_foreign: this.bookingsData[0].currency === "INR" ? 0 : 1,
              entity_public_hash: this.eph,
              entity_hash: this.entityHashId,
              account_hash: localStorage.getItem(
                SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
              ),
            };

            this.ls.showLoader = true;
            this.apiservice.deleteEntityAppointmentData(obj);
          }
        });
      }
    }
  }
  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);
    console.log(curdate);

    return curdate;
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

   opentorate(item: any) {
    let msg =
      environment.base_lookzup_market_website_url +
      "/booking-details?bookingId=" +
      item.hash_id;

    let data = {
      title: "Share details to rate",
      ref: this._modelRef,
      data: msg,
      reference: item,
      entity_hash: this.entityHashId,
      type:1

    }

    this.dialogService.openFullScreenDialog(AskBusinessRatingComponent,data);
  }

  getAccessStatus(): boolean {
    if (this.isOwner) return true;
    else {
      return this.bookingsData[0].operation_access == 1 ? true : false;
    }
  }

  openGoogleMaps(rowvalue:any): void {
    // Construct the Google Maps URL with the provided coordinates
    const mapUrl = `https://www.google.com/maps?q=${rowvalue.lat},${rowvalue.lng}`;

    // Sanitize the URL to make it safe for opening in a new tab
    // const sanitizedUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(mapUrl);
    // console.log(sanitizedUrl.toString());

    // Open a new tab with the Google Maps URL
    window.open(mapUrl, '_blank');
  }
  advancePaymentSettings: any = null;

   isAdvance(): boolean {
    if (
      (this.bookingsData[0].bookingType == 1 &&
        this.advancePaymentSettings?.shop_service == 1) ||
      (this.bookingsData[0].bookingType == 0 &&
        this.advancePaymentSettings?.home_service == 1) ||
      (this.bookingsData[0].bookingType == 2 &&
        this.advancePaymentSettings?.virtual_service == 1)
    ) {
      return true
    }
    return false
  }

   formatDateStringforcancel(datestr: Date): string {
    const now = new Date(datestr);

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

   calculateOnlineTotal(payments: any[]): number {
    const onlineModes = ["RAZORPAY", "PAYPAL"];
    return payments.reduce((accumulator, current) => {
      // Check if the current payment mode is in our online list
      if (onlineModes.includes(current.payment_mode)) {
        // Convert amount to number to ensure mathematical addition
        return accumulator + parseFloat(current.amount);
      }
      return accumulator;
    }, 0); // Start the sum at 0
  }
  isDeleteDisabled(booking: any): boolean {

  if (!booking || !booking.customerInfo) return true;

  const hasCustomer =
    booking.customerInfo.hash_id &&
    booking.customerInfo.hash_id !== 'null';

  const hasPayment = this.hasRazorpayOrPaypalPayment(booking.payments);

  // Same rules you had in *ngIf but inverted
  // Button enabled ONLY when:
  //  - No customer linked
  //  - User is owner
  //  - No payment_ref_id AND paymentMode is not Wallet

  const canDelete =
    !hasCustomer &&
    this.isOwner &&
    !hasPayment;

  return !canDelete;   // disabled when cannot delete
}

hasRazorpayOrPaypalPayment(payments: any[]): boolean {
  if (!Array.isArray(payments)) return false;

  return payments.some(p =>
    typeof p.payment_mode === 'string' &&
    (p.payment_mode.toUpperCase() === 'RAZORPAY' ||
     p.payment_mode.toUpperCase() === 'PAYPAL')
  );
}
  servicereminder(){
     this.router.navigate(['service-reminder'], {relativeTo: this.route})
  }

    viewdetails(item: any) {
    this.router.navigate(["customer-details"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        entityHash: this.entityHashId,
        countryCode: item.country_code,
        phone: item.customerPhone,
        name: item.customer_name,
      },
    });
  }
}
